import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../store/appSlice';
import StickyHeader, { type StickyHeaderConfig } from '../dashboardHeader/StickyHeader';

interface PageOutletProps {
  outletKey: string;
  title: string;
  stickyHeaderConfig?: StickyHeaderConfig;
  children?: React.ReactNode;
  outletContext?: unknown;
}

export default function PageOutlet(props: PageOutletProps) {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([props.outletKey, props.title]));
    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch, props.outletKey, props.title]);

  return (
    <>
      {props.children}
      <Outlet context={props.outletContext} />
      {props.stickyHeaderConfig ? <StickyHeader key={pathname} config={props.stickyHeaderConfig} /> : null}
    </>
  );
}
